import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { LoaderService } from './loader.service';

@Component({
  selector: 'loader',
  templateUrl: 'loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit, OnDestroy {
  public show = false;

  private subscription?: Subscription;

  constructor(private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.subscription = this.loaderService.visible$.subscribe((visible: boolean) => {
      this.show = visible;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
